import React from 'react';
import { Section, FadeIn } from './ui/Section';
import { BookOpen } from 'lucide-react';
import { Button } from './ui/Button';
export function WhatYouGet() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section background="white" data-id="element-306">
      <FadeIn data-id="element-307">
        <h2 className="text-3xl md:text-4xl font-serif text-[#3D1F2E] mb-12 text-center" data-id="element-308">
          Qué obtienes
        </h2>
      </FadeIn>

      <FadeIn delay={0.1} data-id="element-309">
        <div className="flex items-start p-6 md:p-8 bg-[#FFF5F0]/80 backdrop-blur-sm rounded-xl border border-[#E8D5DC] max-w-lg mx-auto" data-id="element-310">
          <div className="flex-shrink-0 p-3 bg-white/80 rounded-lg text-[#C4467E] shadow-sm" data-id="element-311">
            <BookOpen className="w-6 h-6" data-id="element-312" />
          </div>
          <div className="ml-4" data-id="element-313">
            <h3 className="font-bold text-[#3D1F2E] mb-1" data-id="element-314">
              Ebook / guía principal en PDF
            </h3>
            <p className="text-[#7A5C6B] text-sm" data-id="element-315">
              Lectura práctica, directa al grano.
            </p>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-316">
        <div className="mt-14 bg-[#FFF5F0]/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-[#E8D5DC]" data-id="element-317">
          <img src="https://cdn.magicpatterns.com/uploads/h241stnUBcHgWd2SzzrFSw/Anti_impulso_cover.png" alt="Anti-Impulso — Ebook incluido" className="w-full max-w-xl mx-auto rounded-xl" data-id="element-318" />
          <p className="text-center text-[#7A5C6B] text-sm mt-4 italic" data-id="element-319">
            Acceso inmediato desde cualquier dispositivo.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.5} data-id="element-320">
        <div className="mt-10 text-center" data-id="element-321">
          <Button size="lg" withArrow onClick={scrollToPricing} data-id="element-322">
            Quiero empezar hoy
          </Button>
        </div>
      </FadeIn>
    </Section>;
}